import React, { useContext } from 'react';

import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Constants from '../../constants';
import { ThemeContext } from '../../context/ThemeContext';
import { ReactComponent as Logoipsum } from '../../assets/images/brands/icon/logoipsum.svg';
import { ReactComponent as Airbnb } from '../../assets/images/brands/icon/airbnb.svg';
import { ReactComponent as Bookingcom } from '../../assets/images/brands/icon/bookingcom.svg';
import { ReactComponent as Expedia } from '../../assets/images/brands/icon/expedia.svg';
import { ReactComponent as Facebook } from '../../assets/images/brands/icon/facebook.svg';
import { ReactComponent as Google } from '../../assets/images/brands/icon/google.svg';
import { ReactComponent as Hotelscom } from '../../assets/images/brands/icon/hotelscom.svg';
import { ReactComponent as TripAdvisor } from '../../assets/images/brands/icon/tripadvisor.svg';
import { ReactComponent as TrustPilot } from '../../assets/images/brands/icon/trustpilot.svg';
import { ReactComponent as Vrbo } from '../../assets/images/brands/icon/vrbo.svg';
import { ReactComponent as Yelp } from '../../assets/images/brands/icon/yelp.svg';
import { ReactComponent as Yahoo } from '../../assets/images/brands/icon/yahoo.svg';
import { ReactComponent as Pinterest } from '../../assets/images/brands/icon/pinterest.svg';
import { ReactComponent as Twitter } from '../../assets/images/brands/icon/twitter.svg';
import { ReactComponent as TikTok } from '../../assets/images/brands/icon/tiktok.svg';
import { ReactComponent as Instagram } from '../../assets/images/brands/icon/instagram.svg';

const defaulSize = 20;
const defaultFill = '#000000';
const defaultDarkFill = '#ffffff';

function BrandIcon({ brand, size, style, forceFill, ...props }) {
  const { theme } = useContext(ThemeContext);

  let founded = true;
  let BrandComponent;
  let s;
  let fill;
  let darkFill;
  switch (brand) {
    case 'airbnb':
      BrandComponent = Airbnb;
      s = size || defaulSize;
      break;
    case 'booking':
      BrandComponent = Bookingcom;
      s = size || defaulSize;
      break;
    case 'expedia':
      BrandComponent = Expedia;
      s = size || defaulSize;
      break;
    case 'facebook':
      BrandComponent = Facebook;
      s = size || defaulSize;
      break;
    case 'google':
      BrandComponent = Google;
      s = size || defaulSize;
      break;
    case 'hotels':
      BrandComponent = Hotelscom;
      s = size || defaulSize;
      break;
    case 'tripadvisor':
      BrandComponent = TripAdvisor;
      s = size || defaulSize;
      break;
    case 'trustpilot':
      BrandComponent = TrustPilot;
      s = size || defaulSize;
      break;
    case 'vrbo':
      BrandComponent = Vrbo;
      s = size || defaulSize;
      break;
    case 'yelp':
      BrandComponent = Yelp;
      s = size || defaulSize;
      break;
    case 'yahoo':
      BrandComponent = Yahoo;
      s = size || defaulSize;
      break;
    case 'pinterest':
      BrandComponent = Pinterest;
      s = size || defaulSize;
      break;
    case 'twitter':
      BrandComponent = Twitter;
      s = (size || defaulSize) * 0.8;
      break;
    case 'tiktok':
      BrandComponent = TikTok;
      s = size || defaulSize;
      fill = defaultFill;
      darkFill = defaultDarkFill;
      break;
    case 'instagram':
      BrandComponent = Instagram;
      s = size || defaulSize;
      break;
    default:
      BrandComponent = Logoipsum;
      s = size || defaulSize;
      founded = false;
      break;
  }

  const getFill = () => {
    const rule = forceFill || theme;

    return rule === 'dark' ? darkFill : fill;
  };

  return (
    <div
      className="brand-icon-container d-flex align-items-center"
      style={{ height: size, ...style }}
      {...props}
    >
      <div
        className="brand-icon-wrapper d-flex align-items-center justify-content-center"
        style={{ height: s }}
      >
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip>
              {founded ? Constants.Brands[brand].label : 'Logoipsum'}
            </Tooltip>
          }
        >
          <BrandComponent className="brand-icon" fill={getFill()} />
        </OverlayTrigger>
      </div>
    </div>
  );
}

BrandIcon.propTypes = {
  brand: PropTypes.oneOf(Object.keys(Constants.Brands)).isRequired,
  size: PropTypes.number,
  style: PropTypes.objectOf(PropTypes.any),
  forceFill: PropTypes.oneOf(['default', 'dark']),
};

BrandIcon.defaultProps = {
  size: null,
  style: null,
  forceFill: null,
};

export default BrandIcon;
